import '../../../styles/paypal.css'

/**
 * The brand marks shown on the right of each row in the PayPal payment method list, plus the
 * small "Powered by PayPal" line under the card fields. They are drawn with markup rather than
 * imported logos so they scale with the surrounding type and need no extra assets.
 */

export const PaypalWordmark = ({fontSize = 17}) => (
    <span className="pp-wordmark" style={{fontSize: `${fontSize}px`}}>
        <span className="pp-wordmark-pay">Pay</span><span className="pp-wordmark-pal">Pal</span>
    </span>
)

export const PoweredByPaypal = () => (
    <div className="pp-powered">
        <span>Powered by</span>
        <PaypalWordmark fontSize={12}/>
    </div>
)

export const CardSchemeMarks = () => (
    <span className="pp-marks">
        <span className="pp-chip pp-chip-visa">VISA</span>
        <span className="pp-chip">
            <span className="pp-mc-red"></span>
            <span className="pp-mc-orange"></span>
        </span>
        <span className="pp-chip pp-chip-amex">AMEX</span>
        <span className="pp-chip pp-chip-discover">DISCOVER</span>
    </span>
)


export const PayLaterMark = () => (
    <span className="pp-paylater-mark">
        <span className="pp-paylater-mark-badge">P</span>
        <span>Pay Later</span>
    </span>
)

